/* global module, require */
const AddTool = require('./AddTool'),
	Channel = require('./style/Channel'),
	GlassButton = require('./style/GlassButton'),
	Planner = require('./Planner'),
	PlannerDetails = require('./PlannerDetails'),
	PlannerIntro = require('./PlannerIntro'),
	PlannerMeasurements = require('./PlannerMeasurements'),
	PlannerOptions = require('./PlannerOptions'),
	PlannerSteps = require('./PlannerSteps'),
	PlannerStyles = require('./PlannerStyles'),
	PlannerSummary = require('./PlannerSummary'),
	PlannerThanks = require('./PlannerThanks'),
	PostSystem = require('./style/PostSystem'),
	WirePost = require('./style/WirePost'),
	crel = require('./createElement'),
	getSectionName = require('./func/getSectionByLetter'),
	logoImg = require('../res/planner-logo.svg'),
	makeSectionLabel = require('./func/makeFancySectionLabel'),
	rotateImg = require('../res/planner-360.svg');

const PlaceCornerOff = 'Disable Free Draw',
	PlaceCornerOn = 'Enable Free Draw';

function PlannerContainer(container, config = {}) {
	var me = this;

	me.config = config;
	me.quoteListeners = [];

	me.planner = new Planner(config)
		.setCallback('getSectionName', getSectionName)
		.setCallback('makeSectionLabel', makeSectionLabel)
		.addStyle(PostSystem)
		.addStyle(PostSystem, { balustrade: true })
		.addStyle(WirePost)
		.addStyle(GlassButton)
		.addStyle(Channel);

	me.controls = me.planner.controls;
	me.intro = new PlannerIntro(me);
	me.styles = new PlannerStyles(me, config.style);
	me.measurements = new PlannerMeasurements(me, config.measurements);
	me.options = new PlannerOptions(me);
	me.details = new PlannerDetails(me);
	me.summary = new PlannerSummary(me, me.quoteRequested.bind(me));

	me.add = new AddTool(me.planner, me.measurements);
	me.addToDom(container);

	me.steps.activate(me.steps.steps[0]);

	me.animate = me.animate.bind(me);
	requestAnimationFrame(me.animate);

	if (config.demo) this.demoMode();
}

PlannerContainer.prototype.demoMode = function() {
	this.steps.activate(this.measurements);

	// remove menus etc.
	this.steps.element.remove();
	this.main.remove();
	this.placeBtn.remove();

	// expand 3d view
	this.planner.resized();
};

PlannerContainer.prototype.addToDom = function(container) {
	const me = this;
	me.element = container;
	container.classList.add('planner-container');

	me.steps = new PlannerSteps(me)
		.add(me.intro)
		.add(me.styles)
		.add(me.measurements)
		.add(me.options)
		.add(me.details)
		.add(me.summary);

	me.body = crel({ _parent: me.element, className: 'planner-body' });
	me.main = crel({ _parent: me.body, className: 'planner-main' });
	me.topbar = crel({ _parent: me.main, className: 'planner-top-bar' });

	me.logolink = crel({
		_parent: me.topbar,
		_tag: 'a',
		href: 'https://www.3dvisualplanner.com',
		target: '_blank',
	});
	crel({
		_parent: me.logolink,
		_tag: 'img',
		src: logoImg,
		className: 'planner-logo',
	});

	me.content = crel({ _parent: me.main, className: 'planner-content' });

	me.render = crel({ _parent: me.body, className: 'planner-3d' });
	me.planner.addToDom(me.render);

	me.zoomInBtn = crel({
		_tag: 'button',
		_parent: me.render,
		className: 'zoom-in',
		onclick: () => me.move3d(-10),
	});

	me.zoomOutBtn = crel({
		_tag: 'button',
		_parent: me.render,
		className: 'zoom-out',
		onclick: () => me.move3d(10),
	});

	me.zoomOutBtnInner = crel({
		_tag: 'span',
		_parent: me.zoomOutBtn,
		innerText: '-',
	});

	me.zoomInBtnInner = crel({
		_tag: 'span',
		_parent: me.zoomInBtn,
		innerText: '+',
	});

	me.placeBtn = crel({
		_tag: 'button',
		_parent: me.render,
		className: 'place-corner',
		innerText: PlaceCornerOn,
		onclick: me.placeCorner.bind(me),
	});

	me.rotateBtn = crel({
		_tag: 'button',
		_parent: me.render,
		className: 'noscope',
		onclick: me.rotate3d.bind(me),
	});
	crel({ _parent: me.rotateBtn, _tag: 'img', src: rotateImg });
};

PlannerContainer.prototype.activated = function(step) {
	if (step.previous) this.addPrevious(this.content, step.previousLabel);
	if (step.next) this.addNext(this.content, step.nextLabel);

	this.add.stop();
	this.placeBtn.classList.remove('active');

	this.body.classList.remove('single-panel');
	if (step.single) this.body.classList.add('single-panel');

	this.placeBtn.style.display = step.hidePlaceBtn ? 'none' : 'inline-block';
};

PlannerContainer.prototype.addPrevious = function(_parent, innerText = 'Back') {
	return crel({
		_tag: 'button',
		_parent,
		className: 'action-btn secondary',
		innerText,
		onclick: () => this.steps.previous(),
	});
};

PlannerContainer.prototype.addNext = function(_parent, innerText = 'Continue') {
	return crel({
		_tag: 'button',
		_parent,
		className: 'action-btn',
		innerText,
		onclick: () => this.steps.next(),
	});
};

PlannerContainer.prototype.move3d = function(distance) {
	this.planner.camera.translateZ(distance);
};

PlannerContainer.prototype.rotate3d = function() {
	this.controls.autoRotate = !this.controls.autoRotate;
	this.rotateBtn.classList.toggle('active');
};

PlannerContainer.prototype.placeCorner = function() {
	this.add.toggle();

	if (this.add.active) {
		this.placeBtn.classList.add('active');
		this.placeBtn.innerText = PlaceCornerOff;
	} else {
		this.placeBtn.classList.remove('active');
		this.placeBtn.innerText = PlaceCornerOn;
	}
};

PlannerContainer.prototype.animate = function() {
	if (this.controls.autoRotate) this.controls.update();

	this.planner.render();
	requestAnimationFrame(this.animate);
};

PlannerContainer.prototype.addQuoteListener = function(fn) {
	this.quoteListeners.push(fn);
	return this;
};

PlannerContainer.prototype.quoteRequested = function() {
	this.quoteListeners.forEach(l => l(this));

	// activate ending screen
	const thanks = new PlannerThanks(this);

	this.steps.numbers = false;
	this.steps
		.clear()
		.add(thanks)
		.activate(thanks);
};

PlannerContainer.prototype.getQuoteData = function() {
	const skip = ['info', 'transform'];

	function filterConfig(cfg) {
		var newObj = {};
		for (const key in cfg) {
			if (skip.includes(key)) continue;
			var obj = cfg[key];

			if (typeof obj === 'object') obj = filterConfig(obj);
			newObj[key] = obj;
		}

		return newObj;
	}

	return {
		style: this.planner.style.name,
		measurements: this.measurements.data,
		options: {
			config: filterConfig(this.options.config),
			data: this.options.options,
		},
		details: this.details.data,
		image: this.planner.element.toDataURL('image/png'),
	};
};

module.exports = PlannerContainer;
